import { IOffer } from '../../types/offer';
import { IGalleryItem } from '../../types/redux/gallery';
import { ECategory } from '../../types/category';
import { prepareNewbuildingsFlatSaleGallery } from './prepareNewbuildingsFlatSaleGallery';
import { prepareFlatSaleGallery } from './prepareFlatSaleGallery';

export function prepareGallery(offer: IOffer): IGalleryItem[] {
  switch (offer.category) {
    case ECategory.NewBuildingFlatSale:
      return prepareNewbuildingsFlatSaleGallery(offer);
    case ECategory.FlatSale:
      return prepareFlatSaleGallery(offer);
  }

  return prepareNewbuildingsFlatSaleGallery(offer);
}
